const defaultState = {
    isSmallScreenApp: false,
    hasTryLiff: false,
    isZinesEmbedded: false,
    isWidgetEmbedded: false
};

const UPDATE_APP_STATE = 'appState/UPDATE_APP_STATE';

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_APP_STATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default reducer;

export function setIsSmallScreenApp(status) {
    return {
        type: UPDATE_APP_STATE,
        payload: { isSmallScreenApp: status }
    };
}

export function setIsZinesEmbedded() {
    return {
        type: UPDATE_APP_STATE,
        payload: { isZinesEmbedded: true }
    };
}

// 偵測 promo 是否被放在 onsite message 的 widget iframe 中
export function setIsWidgetEmbedded() {
    return {
        type: UPDATE_APP_STATE,
        payload: { isWidgetEmbedded: true }
    };
}
